import { render } from "./AIBlog.vue?vue&type=template&id=a810afa0"
import script from "./AIBlog.vue?vue&type=script&lang=js"
export * from "./AIBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__